total
<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <Tab />
      <div class="page-actions">
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-select
                v-model="tenantId"
                placeholder="商户ID"
                size="mini"
                clearable
              >
                <el-option
                  v-for="item in tabList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="用户ID"
                clearable
                v-model="userId"
                class="userUid_ipt"
                size="mini"
              >
                <!-- <img :src="userUid" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>
          <div class="item">
            <!-- <div class="txt">用户UID</div> -->
            <div class="ipt">
              <el-input
                placeholder="邀请人ID"
                clearable
                v-model="invitedUserId"
                class="userUid_ipt"
                size="mini"
              >
                <!-- <img :src="userUid" alt="" slot="prefix" class="userUid" /> -->
              </el-input>
            </div>
          </div>

          <!-- <div class="item">
         
            <div class="ipt">
              <el-select
                size="mini"
                @change="changeCoin"
                :rules="[
                  { required: true, message: '请选择', trigger: 'change' },
                ]"
                v-model="status"
                placeholder="用户状态"
              >
                
                <el-option
                  v-for="item in [{ value: true, label: '正常' }]"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div> -->

          <div class="item">
            <el-button size="mini" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>
          <div class="item">
            <el-button size="mini" type="primary" @click="handleClearSearch"
              >重置</el-button
            >
          </div>
          <!-- <div class="item">
            <a @click="getExcel" target="_blank">导出Excel</a>
          </div> -->
        </div>
      </div>

      <user-list @refresh="refreshList"></user-list>
    </el-card>
    <!-- 添加用户信息弹框 -->
  </div>
</template>

<script>
import './store'
import UserList from './components/list'
import Tab from '../components/Tab'
import Add from './components/add'
import { mapState, mapActions, mapMutations } from 'vuex'
import moment from 'moment'
import userUid from '@/assets/input/userUid.png'
import invite from '@/assets/input/invite.png'
import channel from '@/assets/input/channel.png'
import api from '../api'

import Del from './components/del'
export default {
  name: 'ContactHistory',
  components: {
    UserList,
    Tab,
    Del,
    Add,
  },
  data() {
    return {
      invite,
      channel,
      userUid,
      dialogVisible: false,
      userId: '',
      invitedUserId: '',
      value1: '',
      status: '',
      // value1: [
      //   moment(new Date().getTime() - 7 * 1000 * 24 * 60 * 60).format(
      //     "YYYY-MM-DD"
      //   ),
      //   new Date().getFullYear() +
      //     "-" +
      //     (new Date().getMonth() + 1) +
      //     "-" +
      //     new Date().getDate(),
      // ],
      tenantId: '',
      tabList: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  computed: {
    ...mapState(['userInfo']),
    ...mapState('topPartner', ['topPartner']),
    ...mapState('userData', [
      'totalRealizedProfit',
      'totalFee',
      'pagination',
      'symbolList',
      'orderBy',
    ]),
  },
  methods: {
    ...mapActions('userData', ['getHistory', 'exportExcel', 'getSymbolList']),

    ...mapMutations('userData', ['setOrderBy', 'setDelVisible']),
    showDel() {
      this.setDelVisible(true)
    },
    changeCoin(e) {
      this.getHistory({
        userId: this.userId,
        invitedUserId: this.invitedUserId,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',

        ...this.pagination,
        page: 1,
      })
    },
    refreshList(data = {}) {
      this.getHistory({
        userId: this.userId,
        invitedUserId: this.invitedUserId,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        ...this.pagination,
        ...data,
      })
    },
    getExcel() {
      this.exportExcel({
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        userId: this.userId,
        invitedUserId: this.invitedUserId,
        ...this.pagination,
      }).then((res) => {
        const link = document.createElement('a')
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' }) //设置文件流
        link.style.display = 'none'
        // 设置连接
        link.href = URL.createObjectURL(blob) //将文件流转化为blob地址
        console.log('link-href', link.href)
        link.download = '历史仓位记录'
        document.body.appendChild(link)
        // 模拟点击事件
        link.click() //设置点击事件
      })
    },

    handleSearch() {
      if (!this.tenantId) {
        this.$message.warning('请输入商户ID进行查询')
        return
      }
      this.getHistory({
        userId: this.userId,
        invitedUserId: this.invitedUserId,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.value1[1] : '',
        tenantId: this.tenantId,
        ...this.pagination,
        page: 1,
      })
    },
    handleClearSearch() {
      this.userId = ''
      this.tenantId = ''
      this.invitedUserId = ''
      this.handleSearch()
    },
    handleSave() {},
    closeDialog() {
      this.dialogVisible = false
    },
    onOpen() {},
    onClose() {
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
    close() {
      // this.$emit("update:visible", false);
      this.$refs['elForm'].resetFields()
      this.dialogVisible = false
    },
    // clearSort() {
    //   this.setOrderBy(null)
    //   this.$refs.table.doSort('', '')
    // },
  },
  created() {
    this.$message.warning('请输入商户ID进行查询')
    api.getTenantList().then((res) => {
      if (res.code == 0) {
        const { data } = res
        this.tabList = data
      }
    })
    // this.getHistory({
    //   userId: this.userId,
    //   invitedUserId: this.invitedUserId,
    //   startTime: this.value1 ? this.value1[0] : '',
    //   endTime: this.value1 ? this.value1[1] : '',

    //   ...this.pagination,
    // })
  },
  beforeDestroy() {
    this.setOrderBy(null)
  },
}
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
